import React from 'react';
import MainDocsScreen from './MainDocsScreen';

function Documents() {
  return <MainDocsScreen />;
}

export default Documents;
